module.exports = __webpack_public_path__ + "img/docs-band.168aec93.svg";